module.exports = __webpack_public_path__ + "img/24.8.TSS.2b499f01.png";